'use strict';

module.exports = {
  Operation: require('./operation'),
  TextOperation: require('./text_operation'),
  ArrayOperation: require('./array_operation'),
  ObjectOperation: require('./object_operation')
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/operator/index.js
 ** module id = 228
 ** module chunks = 0
 **/